import { BookmarkIcon, DeleteIcon } from '../../icons';
import { Box, Button, Typography } from '../../ui';

interface GroupBulkActionBarProps {
  count: number;
  /** Assign is only offered when a single workspace is in scope to
   *  hydrate members against. */
  showAssign: boolean;
  running: boolean;
  onAssign: () => void;
  onDelete: () => void;
  onClear: () => void;
}

/**
 * Bulk action bar — fixed to the viewport bottom, rendered by the
 * orchestrator only when something's selected. Presentational: it reports
 * the selection count and forwards Assign / Delete / Clear.
 */
export default function GroupBulkActionBar({
  count,
  showAssign,
  running,
  onAssign,
  onDelete,
  onClear,
}: GroupBulkActionBarProps) {
  return (
    <Box
      sx={{
        position: 'fixed',
        left: 240, // matches the sidebar offset
        right: 0,
        bottom: 0,
        zIndex: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 3,
        py: 1.25,
        bgcolor: 'rgb(15, 23, 42)',
        color: 'rgba(255,255,255,0.92)',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 -4px 16px rgba(0,0,0,0.18)',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, color: 'inherit' }}>
        {count} selected
      </Typography>
      <Box sx={{ flex: 1 }} />
      {showAssign && (
        <Button
          size="small"
          startIcon={<BookmarkIcon />}
          onClick={onAssign}
          disabled={running}
          sx={{ color: '#bae6fd', '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' } }}
        >
          Assign content
        </Button>
      )}
      <Button
        size="small"
        startIcon={<DeleteIcon />}
        onClick={onDelete}
        disabled={running}
        sx={{ color: '#fca5a5', '&:hover': { bgcolor: 'rgba(252, 165, 165, 0.12)' } }}
      >
        Delete
      </Button>
      <Box sx={{ width: '1px', height: 24, bgcolor: 'rgba(255,255,255,0.15)', mx: 0.5 }} />
      <Button
        size="small"
        onClick={onClear}
        disabled={running}
        sx={{ color: 'rgba(255,255,255,0.6)', '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' } }}
      >
        Clear
      </Button>
    </Box>
  );
}
